// Tiny component for the `/` route. Default redirect is /clients, but
// if the user got to `/` via the MS OAuth callback after kicking off
// sign-in from an invitation page, sessionStorage will hold the path
// to bounce back to (e.g. /invite/<token>) — honour that first.

import { Navigate } from "react-router-dom";

export default function HomeRedirect() {
  let target = "/dashboard";
  try {
    const stashed = window.sessionStorage.getItem("cw:postLoginRedirect");
    if (stashed) {
      target = stashed;
      window.sessionStorage.removeItem("cw:postLoginRedirect");
    }
  } catch {
    // ignore — sessionStorage can throw in private-browsing edge cases
  }
  return <Navigate to={target} replace />;
}
